module.exports = __webpack_public_path__ + "static/image 106-7b7f25d2851f9e1ce36a14ba396d78a0.png";